import { DATE_PICKER_FORMAT } from '@ally/date-utils';
import { getAccountId } from '@ally/transfer-account-utils';
function transferToFormValues(transfer) {
    return {
        fromAccount: getAccountId(transfer.fromAccount),
        toAccount: getAccountId(transfer.toAccount),
        amount: transfer.amount,
        deliveryDate: transfer.deliveryDate.format(DATE_PICKER_FORMAT),
        noteToSelf: transfer.noteToSelf || '',
    };
}
export default transferToFormValues;
//# sourceMappingURL=transferToFormValues.js.map